<!--  -->
<template>
  <div>

     <li @mouseover="showTipInfoState = true"  @mouseout="showTipInfoState = false">
        <div id="mark_div" >      
            <div id="mark_info_box">  
              <span @click="openBook(id)"> {{id + 1}}. ç¬¬{{pageId}}é¡µ </span>
            </div>
            <div id="del_button_box" v-show="showTipInfoState">
                <i id="del_button" title="åˆ é™¤" @click="delBookMark(markId)" class="el-icon-error" ></i>
            </div>
        </div>
    </li>
  </div>
</template>

<script>
export default {
  props: {
    id: Number,   //æ•°ç»„é¡ºåº�Id
    markId: Number, // ä¹¦ç­¾ä¸»é”®Id
    pageId:String,
    markInfo:String,   // ä¹¦ç­¾éš�ç¬”å†…å®¹
    bookInfo:String  // è®°å½•çš„å›¾ä¹¦å†…å®¹  è·³è½¬åˆ°é˜…è¯»ç”¨ï¼ˆå¹¶æ��å�–é‡Œé�¢çš„pageidï¼‰
  },
  data () {
    return {
       showTipInfoState: false
    }
  },
  methods: {
    openBook (id ) {
        this.$parent.openBook(id)
    },
    delBookMark(markId) {
        this.$parent.delBookMark(markId)
    }
  },
  // ç”Ÿå‘½å‘¨æœŸ - åˆ›å»ºå®Œæˆ�ï¼ˆè®¿é—®å½“å‰�thiså®žä¾‹ï¼‰
  created () {

  },
  // ç”Ÿå‘½å‘¨æœŸ - æŒ‚è½½å®Œæˆ�ï¼ˆè®¿é—®DOMå…ƒç´ ï¼‰
  mounted () {

  }
}
</script>
<style scoped>
/* @import url(); å¼•å…¥cssç±» */

  #del_button_box {
    position:absolute;
    right: 5px;
    top: 0px;

  }

  #mark_div {
    position: relative;

  }

  #del_button{
    cursor: pointer;
  }

    #mark_info_box span:hover{
        display: inline-block;
        position: relative;
        top: 1px;
        color: brown;
    }

</style>
